import { render, staticRenderFns } from "./NeedPay.vue?vue&type=template&id=12b9c914&scoped=true"
import script from "./NeedPay.vue?vue&type=script&lang=js"
export * from "./NeedPay.vue?vue&type=script&lang=js"
import style0 from "./NeedPay.vue?vue&type=style&index=0&id=12b9c914&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b9c914",
  null
  
)

export default component.exports